<!--
    我的课程
    功能：展示课程包列表数据
    说明：版本3.0
-->
<template>
  <div
    v-loading="listLoading"
    class="wrapper">
    <div class="top">
      <search-form
        :is-query.sync="listQuery"
        :form-data="formData"
        @onSearch="handlerSearch"/>
    </div>
    <el-scrollbar
      v-if="list.length"
      wrap-style="overflow-x:hidden;"
      style="flex:1;">
      <div class="mian-content">
        <package-item
          v-for="(item, index) in list"
          :key="index"
          :item="item"/>
      </div>
    </el-scrollbar>
    <div
      v-if="isNoData"
      class="no-data">
      <img
        :src="$assets.empty"
        class="empty-img">
      <p>暂无数据</p>
    </div>
    <!-- 分页 -->
    <el-pagination
      v-if="total"
      :current-page.sync="listQuery.page"
      :page-size="parseInt(listQuery.per_page)"
      :total="total"
      background
      layout="prev, pager, next"
      style="text-align: right;"
      @current-change="getList"
    />
  </div>
</template>
<script>
import searchForm from '@/components/AppFilter';
import packageItem from './components/packageItem.vue';
import { formData } from './fields';
import { fetchAuthCourse } from '@/api/myCourse';
import { fetchTag } from '@/api/courseOn';

export default {
  name: 'PackageList',
  components: {
    searchForm,
    packageItem,
  },
  data() {
    return {
      isNoData: false,
      listLoading: false,
      total: 0, // 分页总页数
      listQuery: {
        page: 1,
        per_page: 24,
      },
      list: [],
      formData,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      this.listLoading = true;
      const stage = await fetchTag('stage');
      const subject = await fetchTag('subject');
      const stageArr = [];
      const subjectArr = [];
      stage.items.forEach((item) => {
        stageArr.push({ value: item.id, label: item.name });
      });
      subject.items.forEach((item) => {
        subjectArr.push({ value: item.id, label: item.name });
      });
      this.formData[0].options = stageArr;
      this.formData[1].options = subjectArr;
      this.getList();
    },
    getList() {
      this.listLoading = true;
      fetchAuthCourse(this.listQuery, this.$store.state.choicesSchool.id).then((res) => {
        this.list = res.items;
        this.total = res.meta.total;
        this.isNoData = this.list.length === 0;
      }).finally(() => {
        this.listLoading = false;
      });
    },
    handlerSearch() {
      this.listQuery.page = 1;
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper{
  padding: 24px 34px;
  height: 100vh!important;
  flex: none!important;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  .top{
    padding: 10px 0 15px 0;
  }
  .mian-content{
      display: flex;
      flex-wrap: wrap;
      margin-left: -12px;
      .package-item{
          margin: 0 12px;
      }
  }
  .no-data{
    flex: 1;
    justify-content: center;
    align-items: center;
    display: flex;
    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/MyCourse/packageList/index.vue